import { useEffect, useState } from 'react';
import { Breakpoints } from '../constants/breakpoints';
import useMediaQuery from './useMediaQuery';
const useBreakpoint = () => {
    const [breakpoint, setBreakpoint] = useState(Breakpoints.XSMALL);
    const isXSmallBreakpoint = useMediaQuery(Breakpoints.XSMALL);
    const isSmallBreakpoint = useMediaQuery(Breakpoints.SMALL);
    const isMediumBreakpoint = useMediaQuery(Breakpoints.MEDIUM);
    const isLargeBreakpoint = useMediaQuery(Breakpoints.LARGE);
    const isXLargeBreakpoint = useMediaQuery(Breakpoints.XLARGE);
    const isXxlBreakpoint = useMediaQuery(Breakpoints.XXL);
    useEffect(() => {
        if (isXSmallBreakpoint) {
            setBreakpoint(Breakpoints.XSMALL);
        }
        else if (isSmallBreakpoint) {
            setBreakpoint(Breakpoints.SMALL);
        }
        else if (isMediumBreakpoint) {
            setBreakpoint(Breakpoints.MEDIUM);
        }
        else if (isLargeBreakpoint) {
            setBreakpoint(Breakpoints.LARGE);
        }
        else if (isXLargeBreakpoint) {
            setBreakpoint(Breakpoints.XLARGE);
        }
        else if (isXxlBreakpoint) {
            setBreakpoint(Breakpoints.XXL);
        }
    }, [
        isXSmallBreakpoint,
        isSmallBreakpoint,
        isMediumBreakpoint,
        isLargeBreakpoint,
        isXLargeBreakpoint,
        isXxlBreakpoint,
    ]);
    return breakpoint;
};
export default useBreakpoint;
//# sourceMappingURL=useBreakpoint.js.map